import { Badge, useBreakpointValue } from '@chakra-ui/react'

export const LoggedUserBadge = () => {
  const text = useBreakpointValue({ base: 'Aktuální', md: 'Aktuální uživatel' })

  return <Badge
    sx={{
      position: 'absolute',
      top: -2,
      left: -2,
      boxShadow: 'md',
      transform: 'rotate(-3deg)',
      zIndex: 1
    }}
    backgroundColor="green.50"
    color='green.800'
    variant="solid"
    size='lg'
    fontSize={{ base: '2xs', md: 'md' }}
  >
    {text}
  </Badge>
}